import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FormatDateIso, getYestardaysDate } from "utils/dateUtils";
import { toast } from "react-toastify";
import { useAppDispatch } from "hooks/hooks";
import { useSelector } from "react-redux";
import { selectPartner } from "../../Main/main.slice";
import {
  createPayedPayment,
  getAllAccountPayables,
  selectAccountPayableForPaymentCreation,
  setIndexForPaymentCreation,
  setPaymentCreationPopover,
} from "../accountPayable.slice";
import { ICreatePayedPaymentRequestParams } from "Dashboard/scenes/Partners/domain";
import { Controller, useForm } from "react-hook-form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLongArrowAltDown } from "@fortawesome/free-solid-svg-icons";
import classes from "../../../../../../components/Popover/popover.module.scss";
import classesPartner from "../../../styles/popovers.module.scss";
import { IMaskInput } from "react-imask";

const NewPayedPaymentPopover = () => {
  const dispatch = useAppDispatch();
  const account = useSelector(selectAccountPayableForPaymentCreation);
  const partner = useSelector(selectPartner);

  const {
    handleSubmit,
    register,
    formState: { errors },
    control,
    reset,
  } = useForm<ICreatePayedPaymentRequestParams>({
    defaultValues: { date: getYestardaysDate() }
  });

  const closeDialog = () => {
    dispatch(setIndexForPaymentCreation(-1));
    dispatch(setPaymentCreationPopover({ isOpen: false }));
    reset();
  };

  const onSubmit = async (data: ICreatePayedPaymentRequestParams) => {
    try {
      await dispatch(createPayedPayment(data)).unwrap();
      closeDialog();
      toast.success("Red je uspesno dodat.");
      dispatch(getAllAccountPayables(partner.partnerId));
    } catch (status: any) {
      if (status === 406) {
        toast.error("Unos nije moguć jer postoji neki problem sa ovim saradnikom");
      } else if (status === 404) {
        toast.error("Unos nije moguć jer neki od unetih podataka nije regularan");
      } else if (status === 403) {
        toast.error("Nemate pravo da unosite uplate");
      } else if (status === 400) {
        toast.error("Unos nije moguć zbog neočekivane greške");
      }
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}
      className={`
      ${classesPartner.newAccountReceivablePopover}
      ${classes.basicPopover}`}
    >
      <input
        type="hidden"
        value={account?.payableId}
        {...register("accountPayableId")}
      />

      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}`}>
          <label className={classes.mr5}>br. računa:</label>
          <input
            type="text"
            className={`${classes.itemBorder} ${classes.transparent} ${classes.lightDark}`}
            value={account != null ? account.invoiceId : ""}
            disabled
          />
        </div>
      </div>

      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}`}>
          <label className={classes.mr5}>iznos:</label>
          <Controller
            control={control}
            name="amount"
            defaultValue={undefined}
            rules={{
              required: true,
            }}
            render={({ field: { onChange, value } }) => (
              <IMaskInput
                autoFocus
                onAccept={(value, mask) => onChange({ target: { value: mask.unmaskedValue } })}
                mask={Number}
                className={`${classes.itemBorder} ${errors.amount ? classes.itemError : ""}`}
              />
            )}
          />
        </div>
      </div>

      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}`}>
          <label className={classes.mr5}>datum plaćanja:</label>
          <Controller
            control={control}
            name="date"
            defaultValue={undefined}
            rules={{
              required: true,
            }}
            render={({ field: { onChange, value } }) => (
              <div>
                <DatePicker
                  onChange={(date) =>
                    onChange(date ? FormatDateIso(date) : undefined)
                  }
                  dateFormat="dd.MM.yyyy"
                  showMonthDropdown
                  showYearDropdown
                  selected={value ? new Date(value) : null}
                  className={`${classes.dateItem} ${classes.itemBorder}
                  ${errors.date ? classes.itemError : ""}`}
                />
              </div>
            )}
          />
        </div>
      </div>

      <div className={classes.row}>
        <div className={classes.buttons}>
          <button type="submit" className={classes.iconButton}>
            <FontAwesomeIcon
              icon={faLongArrowAltDown}
              className={classes.icon} />
          </button>
        </div>
      </div>
    </form>
  );
};

export default NewPayedPaymentPopover;
